import Layout from "@/layouts/index.vue";
import router from "@/routers/index";
import { HOME_URL } from "@/config/index";
import * as ElIcon from "@element-plus/icons-vue";
import { SVG_PREFIX } from "@/config/index";

const elIcons = Object.keys(ElIcon); // el-icon name

/**
 * 注意：使用console.log("路由数据", JSON.stringify(generateRoutes(res.data, 0))打印会发现子路由的componet打印不出来，JSON不能打印出来函数。${data[i].component}
 */
// 递归函数用于生成路由配置，登录的时候也需要调用一次。
export function generateRoutes(data: any[], parentId: any) {
  // 首先把你需要动态路由的组件地址全部获取[vue2中可以直接用拼接的方式，但是vue3中必须用这种方式]
  let modules = import.meta.glob("@/views/**/*.vue");
  const routeList: any = [];
  for (let i = 0; i < data.length; i++) {
    if (data[i] && !router.hasRoute(data[i].path)) {
      if (data[i].parentId === parentId) {
        // console.log("component", data[i].component);
        const componentTemplate = data[i].component;
        let effectIcon = data[i].icon ? data[i].icon : "";
        if (effectIcon.indexOf(SVG_PREFIX) == -1 && elIcons.indexOf(effectIcon) == -1) {
          // 无效图标
          effectIcon = "";
        }
        const route: any = {
          path: `${data[i].path}`,
          name: `${data[i].name}`,
          // 这里modules[`/src/views/${componentTemplate}.vue`] 一定要用绝对定位
          component: data[i]?.component ? modules[`/src/views/${componentTemplate}.vue`] : Layout,
          meta: {
            menuId: data[i].menuId,
            parentId: data[i].parentId,
            title: data[i].menuName,
            icon: effectIcon,
            isHide: data[i].isHide,
            isKeepAlive: data[i].isKeepAlive,
            isLink: data[i].isLink,
            isFull: data[i].isFull,
            isAffix: data[i].isAffix,
            subtaskId: data[i].subtaskid,
            whereConfig: data[i].whereconfig,
            collectionTaskId: data[i].relFormId,
            formType: data[i].formType,
            pageId: data[i].pageid,
          },
        };
        if (parseInt(data[i].menuType) === 1) {
          route.redirect = `${data[i]?.redirect}` || HOME_URL;
        }
        // 递归处理子节点
        const children = generateRoutes(data, data[i].menuId);
        if (children.length > 0) {
          route.children = children;
        }
        if (parseInt(data[i].menuType) === 2) {
          routeList.push(route);
        } else if (route.children && route.children.length !== 0) {
          routeList.push(route);
        }
      }
    }
  }
  return routeList;
}

/**
 * 初始化动态路由[用于生成扁平化一级路由，将后端一级路由数据转化为前端router格式的一级路由]
 */
export function generateFlattenRoutes(data: any[]) {
  // 首先把你需要动态路由的组件地址全部获取[vue2中可以直接用拼接的方式，但是vue3中必须用这种方式]
  let modules = import.meta.glob("@/views/**/*.vue");
  const routes: any = [];
  for (let i = 0; i < data.length; i++) {
    // console.log("component",data[i].component)
    const componentTemplate = data[i].component;
    const route: any = {
      path: `${data[i].path}`,
      name: `${data[i].name}`,
      // 这里modules[`/src/views/${componentTemplate}.vue`] 一定要用绝对定位
      component: data[i]?.component ? modules[`/src/views/${componentTemplate}.vue`] : Layout,
      meta: {
        menuId: data[i].menuId,
        parentId: data[i].parentId,
        title: data[i].menuName,
        icon: data[i].icon,
        isHide: data[i].isHide,
        isKeepAlive: data[i].isKeepAlive,
        isLink: data[i].isLink,
        isFull: data[i].isFull,
        isAffix: data[i].isAffix,
        subtaskId: data[i].subtaskid,
        whereConfig: data[i].whereconfig,
        collectionTaskId: data[i].relFormId,
        formType: data[i].formType,
        pageId: data[i].pageid,
      },
    };
    // console.log("component",route.component)
    if (data[i].menuType == "1") {
      route.redirect = `${data[i]?.redirect}` || HOME_URL;
    }
    routes.push(route);
  }
  return routes;
}
